var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4H22V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V4ZM20 7.45L14.14 13.45V13.5C12.955 14.6561 11.0574 14.6337 9.9 13.45L4 7.45V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V7.45ZM5.38 6L11.29 12C11.68 12.3877 12.31 12.3877 12.7 12C12.7 12 14.7 10 18.62 5.95L5.38 6Z",
    fill: "#38e5e2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.c2cd15e51afa0a1c8e9fa4b745b28dc0.svg";
export { ForwardRef as ReactComponent };